import Rails from '@rails/ujs';
import { Turbo } from '@hotwired/turbo-rails';
import '../portal/fork/brand.scss';
import { initBrandPortal } from '../portal/fork/init';

Rails.start();
Turbo.start();
initBrandPortal();
